/** Instagram's own rule for a handle; anything else is not a profile to build a page from. */
export const INSTAGRAM_HANDLE_REGEX = /^[a-z0-9._]{1,30}$/i;

/**
 * The handle in what a person typed or pasted: `@Lisa.La.Profe`, `instagram.com/lisa.la.profe/`
 * or a profile URL with a query. Null when what is left is not a handle.
 */
export function handleFromInput(raw: string): string | null {
  const bare = raw
    .trim()
    .replace(/^(https?:\/\/)?((www|m)\.)?(instagram\.com|instagr\.am)\//i, '')
    .replace(/[/?#].*$/, '')
    .replace(/^@/, '')
    .toLowerCase();
  return INSTAGRAM_HANDLE_REGEX.test(bare) && !NOT_PROFILES.has(bare) ? bare : null;
}

/** First path segments of Instagram URLs that are not a profile: a pasted post or reel link. */
const NOT_PROFILES = new Set(['p', 'reel', 'reels', 'tv', 'stories', 'explore', 'accounts']);
